import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "expansion-display" }
const _hoisted_2 = { class: "definition" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpansionDisplay',
  props: {
    isAnswerCorrect: { type: Boolean },
    definition: {},
    expansion: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(props.isAnswerCorrect ? 'answer correct' : 'answer incorrect')
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createElementVNode("details", null, [
      _createElementVNode("summary", null, _toDisplayString(_ctx.expansion), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.definition), 1)
    ])
  ]))
}
}

})